module.exports = __webpack_public_path__ + "src/font/woff/4217b4ceadd4de6e77694b22b240e64c.woff";